<script setup>
import HeaderProject from '@/components/HeaderProject.vue'

</script>

<template>
    <HeaderProject></HeaderProject>
  <section class="main-wrapper test">
    <h1>testing</h1>

  </section>
</template>

<style lang="scss" scoped>
.test{
    height: 100vh;
    color:white;
    background-color: black;
}
</style>
